import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { Breadcrumb } from '../../models/breadcrumbs.model';

@Injectable({
  providedIn: 'root',
})
export class BreadcrumbService {

  createBreadcrumbs(
    route: ActivatedRouteSnapshot,
  ): Array<Breadcrumb> {
    const breadcrumbs: Array<Breadcrumb> = [];
    let url = '';

    for (let child = route.firstChild; child; child = child.firstChild) {
      const routeURL: string = child.url
        .map((segment) => segment.path)
        .join('/');

      if (routeURL !== '') {
        url += `/${routeURL}`;
      }

      // Capture the label from route data
      let label = child.data['breadcrumb'];

      // If the route has dynamic parameters, use them as labels
      if (child.params['productId']) {
        label = child.params['productId'];
      } else if (child.params['siteId']) {
        label = child.params['siteId'];
      }

      if (label) {
        breadcrumbs.push({
          title: label,
          url,
          productId: child.params['productId'],
          siteId: child.params['siteId'],
        });
      } else if (breadcrumbs.length) {
        breadcrumbs[breadcrumbs.length - 1].url = url;
      }
    }

    return breadcrumbs;
  }
}